import { Button } from 'components/buttons'
import styled from 'styled-components'

export const StyledButton = styled(Button)`
  margin: 10px 0;
`

export const RetryStyledButton = styled(Button)`
  margin: 30px 0 0 0;
`
